var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 26 23"
    },
    viewBox: "0 0 26 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:none;stroke:#000;stroke-width:1.75;stroke-linecap:round}")), /*#__PURE__*/React.createElement("g", {
    id: "Web-Scanner-Designs-Rebuild"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LWS_v3_Help-Landing",
    transform: "translate(-29 -482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Q",
    transform: "translate(28 479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon---problem",
    transform: "translate(3 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Triangle",
    d: "m11-1.7 12.5 21.6h-25L11-1.7z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.75,
      strokeLinejoin: "round"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line-Copy",
    d: "M11 5.3v8.2",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line-Copy-2",
    d: "M11 16.5h0",
    className: "st1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.e0ca07c70c7375a5c10ec778d7e49b65.svg";
export { ForwardRef as ReactComponent };